import {axios, API, SendRequest, toastr, WebsiteCookies} from '@/imports-files/pages/clients/jobs/new';

export class EditJob extends SendRequest {
  async getJobInfo(jobId) {
    try {
      const result = await axios.get( API.client.jobs.GET_JOB.replace('$job_id', jobId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

}
